import styled from 'styled-components'
import { Box } from 'reakit'

const PaddedBox = styled(Box)`
  position: relative;
  padding: 1rem;
`

export default PaddedBox
